<template>
  <div class="flex-center position-ref screen-height">
    <div style="margin-bottom: 10px;">
      <span class="code">404</span>
      <span class="message">Not Found</span>
    </div>
    <div>
      <ul class="list">
        <li class="list__item">
          <el-button type="text">
            <router-link to="/home">Home</router-link>
          </el-button>
        </li>
        <li v-if="isAuthenticated" class="list__item">
          <el-button type="text">
            <router-link to="/">Dashboard</router-link>
          </el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import { ErrorlessRepository } from '../../repositories/Repository';

  export default {
    name: 'ErrorNotFound',
    computed: {
      ...mapState({ auth: state => state.auth }),
      isAuthenticated() {
        return this.auth.user !== null;
      },
    },
    mounted() {
      this.fetchUser();
    },
    methods: {
      ...mapActions({
        fetchUser: 'auth/fetchUser',
      }),
    },
  }
</script>

<style scoped>
  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .position-ref {
    position: relative;
  }

  .full-width {
    width: 100%;
  }

  .screen-height {
    height: 100vh;
  }

  .code {
    border-right: 2px solid;
    font-size: 26px;
    padding: 0 15px 0 15px;
    text-align: center;
  }

  .message {
    font-size: 18px;
    text-align: center;
    padding: 10px;
  }

  .list {
    display: flex;
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
  }

  .list__item {
    margin-left: 5px;
    margin-right: 5px;
  }
</style>
